import React from 'react'
import { Link } from 'react-router-dom'

function Refund() {
    return (
        <>
            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Cancellations and Refund Policy</h1>
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row'>
                    <div className='course-details-inner pt-3 pb-4'>
                        <h2 className='title-default-left title-bar-high'>Cancellations and Refund Policy</h2>
                        <h3 className='sidebar-title'>Limitation of liabilities</h3>
                        <ul className='learning-outcomes'>
                            <li>We are liable to delivery selected service/course you against payment.</li>
                            <li>We are only laible to which we have committed to delivery.</li>
                            <li>If ITTCouncil failed to delivery you we are liable to refund you 100% amount.</li>
                        </ul>
                        <h3 className='sidebar-title pt-3'>Application Cancellation and Refund policy for Student</h3>
                        <ul className='learning-outcomes'>
                            <li>Before 1 Day 70% Refund on Registration fee.</li>
                            <li>Between 1 Day to 5 Days 50% Refund on Registration fee.</li>
                            <li>No refund after the above prescribed time limit.</li>
                            <li>Exam Fees no refund as any circumstance.</li>
                        </ul>
                        <h3 className='sidebar-title pt-3'>Application Cancellation and Refund policy for Authorised Training Center</h3>
                        <ul className='learning-outcomes'>
                            <li>Before 1 Day 70% Refund on Registration fee.</li>
                            <li>Between 1 Day to 2 Days 30% Refund on Registration fee.</li>
                            <li>No refund after the above prescribed time limit.</li>
                        </ul>
                        <h2 className='title-default-left title-bar-high pt-3'>How do returns work?</h2>
                        <h3 className='sidebar-title pt-3'>You can raise a request to cancellations your application simple steps:</h3>
                            <ul className='learning-outcomes'>
                                <li>visit our website <b><Link to='/'>www.ittcouncil.com</Link></b></li>
                                <li>Click on <b>Contact</b> Tab</li>
                                <li>Fill Contact With Us Form and Click <b>Send Message</b> Button</li>
                                <li>Communicated our Executive</li>
                            </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Refund